import ImageBlockElement from '@/domain/scene/generic/ImageBlockElement.js'
import { lengthContraction } from '@/domain/physics/SpecialRelativity.js'

const TRAIN_TRACKS_ELEM_NAME = 'TrainTracks'
const TRAIN_TRACKS_WIDTH_REL = 4
const TRAIN_TRACKS_HEIGHT_REL = 0.06
const TRAIN_TRACKS_INIT_X_REL = 0
const TRAIN_TRACKS_INIT_Y_REL = 0.45
const TRAIN_TRACKS_COLOR = 'rgb(64, 64, 64)'
const TRAIN_TRACKS_IMG = require('@/assets/train-tracks.png')

const TRAIN_TRACKS_IMAGE_WIDTH = 240
const TRAIN_TRACKS_IMAGE_HEIGHT = 240

export {
  TRAIN_TRACKS_IMG
}

export default class TrainTracks extends ImageBlockElement {
  constructor () {
    super(
      TRAIN_TRACKS_ELEM_NAME,
      TRAIN_TRACKS_WIDTH_REL,
      TRAIN_TRACKS_HEIGHT_REL,
      TRAIN_TRACKS_INIT_X_REL,
      TRAIN_TRACKS_INIT_Y_REL,
      TRAIN_TRACKS_COLOR,
      TRAIN_TRACKS_IMG,
      TRAIN_TRACKS_IMAGE_WIDTH,
      TRAIN_TRACKS_IMAGE_HEIGHT
    )

    this.fillPatternRepeat = 'repeat-x'
  }

  setOnScene (sceneWidth, sceneHeight, speedC = null) {
    super.setOnScene(sceneWidth, sceneHeight, speedC)

    this.fillPatternScaleX = sceneHeight * this.heightRel / this.imageWidth

    if (speedC !== null) {
      this.fillPatternScaleX = lengthContraction(this.fillPatternScaleX, speedC)
    }
  }
}
